export default __webpack_public_path__ + "static/char-40-anr-68faf75c65e14516b04c2de0a4002baa.gif";